"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const DEBUG_1 = require("@src/DEBUG");
DEBUG_1.DEBUG.open('/init/init.component.ts');
const core_1 = require("@angular/core");
const router_1 = require("@angular/router");
const material_1 = require("@angular/material");
const BaseComponent_1 = require("../commons/BaseComponent");
const app_service_1 = require("../commons/app.service");
const application_events_service_1 = require("../xs/services/events/application-events.service");
class InitComponent extends BaseComponent_1.BaseComponent {
    constructor(service, route, router, snackBar, dialog, applicationEvents) {
        super(router, snackBar, dialog);
        this.service = service;
        this.route = route;
        this.router = router;
        this.snackBar = snackBar;
        this.dialog = dialog;
        DEBUG_1.DEBUG.log('/init/init.component.ts');
    }
    ngOnInit() {
        DEBUG_1.DEBUG.log('/init/init.component.ts', 'onInit()');
    }
    componentAdded(comp) {
        this.curComponent = comp;
        DEBUG_1.DEBUG.log('/init/init.component.ts', 'componentAdded()', comp);
    }
}
exports.InitComponent = InitComponent;
